import { IBalanceContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const BalanceContext = createContext<IBalanceContextData>({} as IBalanceContextData);
